module.exports = __webpack_public_path__ + "static/text-and-graph-2d700e52dcbed4392b2251de4949df3a.png";